import Solution from "features/cases/blocks/Solution";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

import PageLayout from "../../common/PageLayout";

function getProblemIdFromQuery(): string | undefined {
  const hashQuery = window.location.hash.includes("?")
    ? window.location.hash.split("?")[1]
    : "";

  return (
    new URLSearchParams(
      hashQuery || window.location.search.replace(/^\?/, ""),
    ).get("problemId") ?? undefined
  );
}

const SolutionPage: React.FC = () => {
  const { problemId, solutionId } = useParams<{
    problemId: string;
    solutionId: string;
  }>();
  const effectiveProblemId = problemId ?? getProblemIdFromQuery();

  const [solsExpanded, setSolsExpanded] = useState(false);
  const [probExpanded, setProbExpanded] = useState(true);
  const [caseExpanded, setCaseExpanded] = useState(false);

  return (
    <PageLayout
      withFooter={false}
      limitedWidth={false}
    >
      <Solution
        solutionId={solutionId}
        problemId={effectiveProblemId}
        solsExpanded={solsExpanded}
        setSolsExpanded={setSolsExpanded}
        probExpanded={probExpanded}
        setProbExpanded={setProbExpanded}
        caseExpanded={caseExpanded}
        setCaseExpanded={setCaseExpanded}
      />
    </PageLayout>
  );
};

export default SolutionPage;
